import { Component, OnInit } from '@angular/core';
import { FormEntryComponentClass, FormComponentLookup } from '@ptl/forms';
import { ReducerUtilityService } from '@ptl/state';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';


@FormComponentLookup('zip-county-review')
@Component({
    selector: 'app-zip-county-review',
    templateUrl: './entry-zip-county-review.component.html',
    styleUrls: ['./entry-zip-county-review.component.scss'],
    standalone: false
})

export class EntryZipCountyReviewComponent extends FormEntryComponentClass implements OnInit {

  stateValues: any;

  constructor(
    protected reducerUtilityService: ReducerUtilityService
  ) {
    super();
  }

  ngOnInit(): void {

    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getComponentStates().ZipCounty;
    this.stateValues = zipCountyState;

  }

}

